// eslint-disable-next-line
export default class Filter {
  constructor () {
    return {
      searchId: '',
      statusId: null,
      owner: null,
      peaName: '',
      costCenter: '',
      budget: '',
      reason: '',
      deptId: null,
      divisionId: null,
      emergency: '',
      desc: '',
      allText: '',
      commentUserId: null,
      approveUserId: null,
      estCostFrom: null,
      estCostTo: null,
      acri5To: null,
      acri5From: null,
      acri10To: null,
      acri10From: null,
      ccri5To: null,
      ccri5From: null,
      ccri10To: null,
      ccri10From: null,
      assetClassFrom: null,
      assetClassTo: null,
      assetClassId: null,
      assetCatFrom: null,
      assetCatTo: null,
      assetCatId: null,
      plannedStartFrom: null,
      plannedStartTo: null,
      plannedComFrom: null,
      plannedComTo: null,
      historyStatusId: null,
      statusTo: null,
      statusFrom: null,
      filterString: '',
      buildFilterString: function () {
        this.filterString = ''
        if (this.searchId !== '') {
          this.filterString += 'peaId:' + this.searchId
        }
        if (this.statusId !== '' && this.statusId !== null) {
          this.filterString += ',status:' + this.statusId
        }
        if (this.owner !== '' && this.owner !== null) {
          this.filterString += ',owner:' + this.owner
        }
        if (this.peaName !== '' && this.peaName !== null) {
          this.filterString += ',peaName:' + this.peaName
        }
        if (this.costCenter !== '' && this.costCenter !== null) {
          this.filterString += ',costCenter:' + this.costCenter
        }
        if (this.budget !== '' && this.budget !== null) {
          this.filterString += ',budget:' + this.budget
        }
        if (this.reason !== '' && this.reason !== null) {
          this.filterString += ',reason:' + this.reason
        }
        if (this.deptId !== '' && this.deptId !== null) {
          this.filterString += ',deptId:' + this.deptId
        }
        if (this.divisionId !== '' && this.divisionId !== null) {
          this.filterString += ',divisionId:' + this.divisionId
        }
        if (this.emergency !== '' && this.emergency !== null) {
          this.filterString += ',emergency:' + this.emergency
        }
        if (this.desc !== '' && this.desc !== null) {
          this.filterString += ',desc:' + this.desc
        }
        if (this.allText !== '' && this.allText !== null) {
          this.filterString += ',allText:' + this.allText
        }
        if (this.commentUserId !== '' && this.commentUserId !== null) {
          this.filterString += ',commentUserId:' + this.commentUserId
        }
        if (this.approveUserId !== '' && this.approveUserId !== null) {
          this.filterString += ',approveUserId:' + this.approveUserId
        }
        if (this.estCostTo !== '' && this.estCostTo !== null && this.estCostTo !== 0 && this.estCostTo !== 0.00) {
          this.filterString += ',estCostTo:' + this.estCostTo
        }
        if (this.estCostFrom !== '' && this.estCostFrom !== null && this.estCostFrom !== 0 && this.estCostFrom !== 0.00) {
          this.filterString += ',estCostFrom:' + this.estCostFrom
        }
        if (this.acri5To !== '' && this.acri5To !== null) {
          this.filterString += ',acri5To:' + this.acri5To
        }
        if (this.acri5From !== '' && this.acri5From !== null) {
          this.filterString += ',acri5From:' + this.acri5From
        }
        if (this.acri10To !== '' && this.acri10To !== null) {
          this.filterString += ',acri10To:' + this.acri10To
        }
        if (this.acri10From !== '' && this.acri10From !== null) {
          this.filterString += ',acri10From:' + this.acri10From
        }
        if (this.ccri5To !== '' && this.ccri5To !== null) {
          this.filterString += ',ccri5To:' + this.ccri5To
        }
        if (this.ccri5From !== '' && this.ccri5From !== null) {
          this.filterString += ',ccri5From:' + this.ccri5From
        }
        if (this.ccri10To !== '' && this.ccri10To !== null) {
          this.filterString += ',ccri10To:' + this.ccri10To
        }
        if (this.ccri10From !== '' && this.ccri10From !== null) {
          this.filterString += ',ccri10From:' + this.ccri10From
        }
        if (this.assetClassFrom !== '' && this.assetClassFrom !== null && this.assetClassFrom !== 0 && this.assetClassFrom !== 0.00) {
          this.filterString += ',assetClassFrom:' + this.assetClassFrom
        }
        if (this.assetClassTo !== '' && this.assetClassTo !== null && this.assetClassTo !== 0 && this.assetClassTo !== 0.00) {
          this.filterString += ',assetClassTo:' + this.assetClassTo
        }
        if (this.assetClassId !== '' && this.assetClassId !== null) {
          this.filterString += ',assetClassId:' + this.assetClassId
        }
        if (this.assetCatFrom !== '' && this.assetCatFrom !== null && this.assetCatFrom !== 0 && this.assetCatFrom !== 0.00) {
          this.filterString += ',assetCatFrom:' + this.assetCatFrom
        }
        if (this.assetCatTo !== '' && this.assetCatTo !== null && this.assetCatTo !== 0 && this.assetCatTo !== 0.00) {
          this.filterString += ',assetCatTo:' + this.assetCatTo
        }
        if (this.assetCatId !== '' && this.assetCatId !== null) {
          this.filterString += ',assetCatId:' + this.assetCatId
        }
        if (this.plannedStartFrom !== '' && this.plannedStartFrom !== null) {
          this.filterString += ',plannedStartFrom:' + this.plannedStartFrom.toLocaleDateString('en-US')
        }
        if (this.plannedStartTo !== '' && this.plannedStartTo !== null) {
          this.filterString += ',plannedStartTo:' + this.plannedStartTo.toLocaleDateString('en-US')
        }
        if (this.plannedComFrom !== '' && this.plannedComFrom !== null) {
          this.filterString += ',plannedComFrom:' + this.plannedComFrom.toLocaleDateString('en-US')
        }
        if (this.plannedComTo !== '' && this.plannedComTo !== null) {
          this.filterString += ',plannedComTo:' + this.plannedComTo.toLocaleDateString('en-US')
        }
        if (this.historyStatusId !== '' && this.historyStatusId !== null) {
          this.filterString += ',historyStatusId:' + this.historyStatusId
        }
        if (this.statusTo !== '' && this.statusTo !== null) {
          this.filterString += ',statusTo:' + this.statusTo.toLocaleDateString('en-US')
        }
        if (this.statusFrom !== '' && this.statusFrom !== null) {
          this.filterString += ',statusFrom:' + this.statusFrom.toLocaleDateString('en-US')
        }
        if (this.filterString.substr(0, 1) === ',') {
          this.filterString = this.filterString.substr(1, this.filterString.length)
        }
        this.filterString = encodeURIComponent(this.filterString)
      },
      splitString: function (queryString) {
        var params = queryString.split(',')
        for (var i in params) {
          var pair = params[i].split(':')
          switch (pair[0]) {
            case 'peaId':
              this.searchId = parseInt(pair[1])
              break
            case 'status':
              this.statusId = parseInt(pair[1])
              break
            case 'owner':
              this.owner = parseInt(pair[1])
              break
            case 'peaName':
              this.peaName = pair[1]
              break
            case 'costCenter':
              this.costCenter = pair[1]
              break
            case 'budget':
              this.budget = pair[1]
              break
            case 'reason':
              this.reason = pair[1]
              break
            case 'deptId':
            case 'department':
              this.deptId = parseInt(pair[1])
              break
            case 'divisionId':
              this.divisionId = parseInt(pair[1])
              break
            case 'emergency':
              this.emergency = pair[1]
              break
            case 'desc':
              this.desc = pair[1]
              break
            case 'allText':
              this.allText = pair[1]
              break
            case 'commentUserId':
              this.commentUserId = parseInt(pair[1])
              break
            case 'approveUserId':
              this.approveUserId = parseInt(pair[1])
              break
            case 'estCostTo':
              this.estCostTo = parseFloat(pair[1]).toFixed(2)
              break
            case 'estCostFrom':
              this.estCostFrom = parseFloat(pair[1]).toFixed(2)
              break
            case 'acri5To':
              this.acri5To = parseInt(pair[1])
              break
            case 'acri5From':
              this.acri5To = parseInt(pair[1])
              break
            case 'acri10To':
              this.acri10To = parseInt(pair[1])
              break
            case 'acri10From':
              this.acri10From = parseInt(pair[1])
              break
            case 'ccri5To':
              this.ccri5To = parseInt(pair[1])
              break
            case 'ccri5From':
              this.ccri5From = parseInt(pair[1])
              break
            case 'ccri10To':
              this.ccri10To = parseInt(pair[1])
              break
            case 'ccri10From':
              this.ccri10From = parseInt(pair[1])
              break
            case 'assetClassId':
              this.assetClassId = parseInt(pair[1])
              break
            case 'assetClassTo':
              this.assetClassTo = parseFloat(pair[1]).toFixed(2)
              break
            case 'assetClassFrom':
              this.assetClassFrom = parseFloat(pair[1]).toFixed(2)
              break
            case 'assetCatId':
              this.assetCatId = parseInt(pair[1])
              break
            case 'assetCatTo':
              this.assetCatTo = parseFloat(pair[1]).toFixed(2)
              break
            case 'assetCatFrom':
              this.assetCatFrom = parseFloat(pair[1]).toFixed(2)
              break
            case 'plannedStartFrom':
              this.plannedStartFrom = new Date(pair[1])
              break
            case 'plannedStartTo':
              this.plannedStartTo = new Date(pair[1])
              break
            case 'plannedComFrom':
              this.plannedComFrom = new Date(pair[1])
              break
            case 'plannedComTo':
              this.plannedComTo = new Date(pair[1])
              break
            case 'historyStatusId':
              this.historyStatusId = parseInt(pair[1])
              break
            case 'statusTo':
              this.statusTo = new Date(pair[1])
              break
            case 'statusFrom':
              this.statusFrom = new Date(pair[1])
              break
            default:
          }
        }
      }
    }
  }
}
